export default __webpack_public_path__ + "static/media/red-eyes.891b40a7.png";